export enum TodaysTripEndpointKeys {
  GET_TODAYS_TRIP_AWS_URL = 'GET_TODAYS_TRIP_AWS_URL',
  APP_AUTH_CONFIG_JSON = 'APP_AUTH_CONFIG_JSON'
}

export enum HTTP_HEADERS {
  TRANSACTION_ID_PREFIX = 'todays-trips',
  CONTENT_TYPE = 'application/json',
  FORM_URLENCODED = 'application/x-www-form-urlencoded',
  TODAYS_TRIP = 'TodaysTrip',
  CHANNEL_ID = 'DCOM',
  GUEST = 'GUEST',
  BEARER = 'Bearer'
}

export enum IDP_APP {
  MY_TRIPS = 'MY_TRIPS'
}
export enum MyTripEndpointKeys {
  CHECK_IN_ACTION = 'CHECK_IN_ACTION',
  CHECK_IN_AWS_URL = 'CHECK_IN_AWS_URL',
  REBOOK_ME_FLOW = 'REBOOK_ME_FLOW'
}
